import axios from "../utils/axios";

export const getShiftPlans = () => {
    return axios.get(`/Shift/GetShift`);
};

export const addShiftPlan = (payload) => {
    return axios.post(`/Shift/AddShift`, payload);
};

export const updateShiftPlan = (payload) => {
    return axios.put(`/Shift/UpdateShift`, payload);
};

export const deleteShiftPlan = (payload) => {
    return axios.delete(`/Shift/DeleteShift?shiftPlanId=${payload}`);
};
